import { render } from "./sms-opt-in-input.vue?vue&type=template&id=74560553"
import script from "./sms-opt-in-input.vue?vue&type=script&lang=js"
export * from "./sms-opt-in-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__